import React from 'react'
import Banner_1 from '../../../assets/images/home_page_7/banner/01.png'
import Banner_2 from '../../../assets/images/home_page_7/banner/02.png'
import Banner_3 from '../../../assets/images/home_page_7/banner/03.png'
import Banner_4 from '../../../assets/images/home_page_7/banner/04.png'

const Banner = () => {
    return (
        <>
            <section id="home-seven" className="home-seven-main-block">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="home-seven-banner-dtl">
                                <h6 className="home-seven-sub-title">
                                    Exclusive Offer{" "}
                                    <span className="badge text-bg-primary">-20%Off</span>
                                </h6>
                                <h1 className="home-seven-title">Achieve Digital Brilliance</h1>
                                <p>We have prepared special discounts for you on electronic</p>
                                <form>
                                    <div className="form-group">
                                        <select
                                            className="form-select"
                                            aria-label="Default select example"
                                        >
                                            <option selected="">Categories</option>
                                            <option value={1}>Fashion</option>
                                            <option value={2}>Accessories</option>
                                            <option value={3}>Electronics</option>
                                        </select>
                                        <div className="form-group-input">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="search"
                                                placeholder="Search your products...."
                                            />
                                            <button type="button" className="btn btn-primary-seven">
                                                Search <i className="flaticon-right-arrow" />
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="home-seven-img">
                                <div className="home-seven-vector-one">
                                    <div className="vector-brd" />
                                    <div className="vector-bg-one" />
                                    <div className="vector-bg-two" />
                                    <div className="vector-bg-three" />
                                </div>
                                <div className="outer-circle">
                                    <div className="inner-circle">
                                        <div className="inner-img">
                                            <img
                                                src={Banner_1}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="home-seven-vector-two">
                                    <div className="vector-tri-one">
                                        <img
                                            src={Banner_2}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                    <div className="vector-tri-two">
                                        <img
                                            src={Banner_3}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                    <div className="vector-tri-three">
                                        <img
                                            src={Banner_4}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div className="home-seven-bg-img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Banner
